import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';
import { IMyDate, IMyDateModel, IMyDpOptions } from 'mydatepicker';

@Injectable({
  providedIn: 'root'
})
export class DateHelperService {
  dateFormat = 'dd/mm/yyyy';
  dateFormats = {
    0: 'DD/MM/YYYY',
    1: 'DD/MM/YYYY HH:mm:ss',
    2: 'YYYY/MM/DD',
    3: 'MMM YY',
    4: 'DD-MM-YYYY'
  };
  constructor() { }

  convertDate(date: string, format?: number) {
    const dateFormat = this.dateFormats[format || 0] || '';
    return moment(date).format(dateFormat);
  }

  currentDateForDP(date?: any): IMyDate {
    let dates: Moment;
    if (date) {
      dates = moment(date);
      dates.subtract(1, 'days');
    } else {
      dates = moment();
      dates.subtract(1, 'days');
    }
    // console.log({
    //   month: dates.month() + 1,
    //   day: dates.date(),
    //   year: dates.year()
    // });
    return {
      month: dates.month() + 1,
      day: dates.date(),
      year: dates.year()
    };
  }

  moment(format?: number, date?: string): string | Moment {
    const myMoment = moment(date || undefined);
    const form = myMoment.format(this.dateFormats[format || 0]);
    return format > -1 ? form : myMoment;
  }

  /** get the date format for web service */
  getDateFormater(date: IMyDateModel | any, format?): string {
    if (!date) return date;
    const data: any = format ? date : date.formatted;
    if (!data) return data;
    const myMoment = moment(data, this.dateFormats[0]);
    return myMoment.format(this.dateFormats[format || 2]);
  }

  /** get the date format for web service */
  getDateFormaterClone(date: IMyDateModel | any, format?): string {
    if (!date) return date;
    const data: any = date.formatted;
    if (!data) return data;
    const myMoment = moment(data, this.dateFormats[0]);
    return myMoment.format(this.dateFormats[format || 2]);
  }

  /** convert the date format for datePicker */
  setDateFormater(val: string, format?: string) {
    let dat = '';
    if (format === 'IN' || !val) {
      dat = val;
    } else {
      dat = this.convertDate(val);
    }
    return <IMyDateModel | any>{ formatted: dat };
  }

  startAndEndDateOfTheWeek(date?) {
    const myMoment = date ? moment(date, this.dateFormats[0]) : moment();
    myMoment.locale('nl'); // week start on monday
    // console.log(m);
    return {
      // startDate: m.startOf('week').format(this.dateFormats[2]),
      // endDate: m.endOf('week').format(this.dateFormats[2])
      startDate: myMoment.weekday(0).format(this.dateFormats[2]),
      endDate: myMoment.weekday(6).format(this.dateFormats[2])
    };
  }

  /** Get the start and end date of the month from the given month */
  getMonthDateRange() {
    const date = this.currentDateForDP();
    // month in moment is 0 based, so 9 is actually october, subtract 1 to compensate
    // array is 'year', 'month', 'day', etc
    const startDate = moment([date.year, date.month - 1]);

    // Clone the value before .endOf()
    const endDate = moment(startDate).endOf('month');

    // make sure to call toDate() for plain JavaScript date type
    return {
      startDate: startDate.format(this.dateFormats[2]),
      endDate: endDate.format(this.dateFormats[2])
    };
  }

  disableTillDate(
    options: IMyDpOptions,
    parentOption: IMyDpOptions,
    ev?: string,
    text?: string,
    format?: string
  ): IMyDpOptions {
    const data = <IMyDpOptions>this.copy(options);
    const parent = <IMyDpOptions>this.copy(parentOption);
    let date: IMyDate;
    const defaultProp = 'disableUntil';
    const prop = text || defaultProp;
    const subDay = prop === defaultProp ? 1 : -1;
    const fomats = this.dateFormats[format === 'IN' ? 0 : 2];
    if (ev) {
      const myday = moment(ev, fomats);
      const finalDate = myday.subtract(subDay, 'days');
      date = {
        day: finalDate.date(),
        month: finalDate.month() + 1,
        year: finalDate.year()
      };
    } else {
      date = parent[prop];
    }
    data[prop] = date || {
      day: 0,
      month: 0,
      year: 0
    };
    return data;
  }

  highLightDates(
    options: IMyDpOptions,
    arr: any[],
    format?: string
  ): IMyDpOptions {
    const data: IMyDpOptions = this.copy(options);
    let temp = [];
    if (arr[0]) {
      temp = arr.map(res => {
        const dateFormat = this.dateFormats[format ? 0 : 2];
        const myMoment = moment(res, dateFormat);
        const day = myMoment.date();
        const month = myMoment.month() + 1;
        const year = myMoment.year();
        return { day, month, year };
      });
    }
    data.highlightDates = temp;
    return data;
  }

  copy(data: any): any {
    return JSON.parse(JSON.stringify(data));
  }

  testValidates(form: any, first: any[], second: any[]) {
    form.get(first[0]).valueChanges.subscribe(val => {
      second[1] = this.disableTillDate(second[1], second[0], val);
    });
    form.get(first[1]).valueChanges.subscribe(val => {
      second[0] = this.disableTillDate(
        second[0],
        second[1],
        val,
        'disableSince'
      );
    });
  }

  timeDifference(date) {
    const now = moment(); // todays date
    const end = moment(date); // another date
    const duration = moment.duration(now.diff(end));
    const hours = duration.asSeconds();
    return Math.abs(hours);
  }

  getDaysMonthYear(startDate, EndDate) {
    let startDt = moment(startDate);
    let endDt = moment(EndDate);

    let days: any[] = [];
    let intervals: any[] = ['years', 'months', 'weeks', 'days'];

    let out = [];
    for (var i = 0; i < intervals.length; i++) {
      var diff = endDt.diff(startDt, intervals[i]);
      if (intervals[i] === 'days') {
        days = this.daysBetweenDate(startDt, endDt) || [];
      }
      out.push(diff);
    }
    out.push(days);
    console.log(out);
    return out;
  };

  daysBetweenDate(startDate, EndDate) {
    const days = [];
    while (startDate <= EndDate) {
      days.push(startDate.format('dddd'));
      startDate.add(1, 'days');
    }
    //console.log(days);
    return days;
  }

}
